export const ROOT = '/ERFAPI';
export const CoAROOT = '/ConfigurationOfApproversAPI';
export const EQUIPMENTROOT = '/EquipmentListAPI';
export const EQUIPMENTLIST = `${EQUIPMENTROOT}/getequipmentlistddl`;
export const EQUIPMENTREQUESTLIST = `${ROOT}/equipmentrequestlist`;
export const EQUIPMENTREQUEST = `${ROOT}/EquipmentRequest`;
export const LATEST_ERF_ID = `${ROOT}//getlatesterfid`;
export const LIST = `${ROOT}/geterfbypage`;
export const APPROVAL = `${ROOT}/approval`;
export const UPDATEAPPROVER = `${ROOT}/changeapprover`
export const APPROVERS_DDL = `${CoAROOT}/getapproversddl`;
export const ISAPPROVEREXIST = `${ROOT}/isapproverexist`;
export const EXPORT = `${ROOT}/export`;
export const SUMMARY_EXPORT = `${ROOT}/summaryexport`;
export const EQUIPMENT_TYPE = `${ROOT}/getequipmentType`;
export const REQUESTOR_NAME = `${ROOT}/getrequestorName`;
export const DEPARTMENT_NAME = `${ROOT}/getdepartmentName`;
export const PROJECT_LEADER = `${ROOT}/getprojectLeader`;
export const JOB_TITLE = `${ROOT}/getjobTitle`;
export const JOB_LEVEL = `${ROOT}/getjobLevel`;
export const GET_HOLIDAY_DATES = `${ROOT}/getholidaydates`;
export const GET_HIRED_CANDIDATES = `${ROOT}/gethiredcandidates`;

export const GETMODULEAPPROVERDDL = `${CoAROOT}/getapproversddl`;
export const EMPLOYEESV = `${CoAROOT}/getemployeesaboveSVddl`;